import React from 'react';
import PropTypes from 'prop-types';
import { Image, CircleName, Wrapper } from './style';
import { getInitials } from '../../../utils/nameFormat';

const CircleImage = ({
  src = '',
  size = 36,
  fullText,
  name = {},
  onClick,
  style = {},
  color = '#FFFFFF',
  bgColor = '#0081dd',
  className = '',
}) => {
  return (
    <Wrapper onClick={onClick} style={style} size={size} className={className}>
      {src ? (
        <Image source={src} />
      ) : (
        <CircleName bgColor={bgColor} color={color} size={size}>
          <span className="initials">{fullText ?? getInitials(name)}</span>
        </CircleName>
      )}
    </Wrapper>
  );
};

CircleImage.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
  name: PropTypes.object,
  onClick: PropTypes.func,
  style: PropTypes.object,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  fullText: PropTypes.string,
  className: PropTypes.string,
};

export default CircleImage;
